export default __webpack_public_path__ + "assets/fonts/Nunito-Regular-88ac52cc.woff2";